import { format } from 'date-fns';
import { getAccessToken } from '../authentication/supabaseService';
import { EmailProductData, TaxCalculationMethod } from '../../stores/appOrderHistoryStore';
import { Platform } from '../../types/Platforms';

export interface FactuurOrder {
  factuurOrderId: string;
  orderHistoryId: string | null;
  orderNumber: string;
  orderDate: string;
  total: number | null;
  totalWithTaxes: number | null;
  productData: EmailProductData[];
  taxRate?: number;
  taxCalculationMethod?: TaxCalculationMethod;
  orderSourceFileUrl: string | null;
  restaurantPlatformId: string;
}

export interface Factuur {
  id: string;
  invoiceNumber: string;
  invoiceDate: string;
  platform: Platform;
  restaurantPlatformId: string;
  restaurantId: string;
  total: number;
  totalWithTaxes: number | null;
  discount: number | null;
  shipping: number | null;
  sourceFileUrl: string | null;
  orders: FactuurOrder[];
}

export async function fetchFacturenByPlatformIds(
  platformIds: string[], startDate: Date, endDate: Date, signal?: AbortSignal
): Promise<Factuur[]> {
  const token = await getAccessToken();
  const response = await fetch('/api/facturen/getByPlatformIds', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    // Calendar dates preserve the selected day across browser/server time zones.
    body: JSON.stringify({ platformIds, startDate: format(startDate, 'yyyy-MM-dd'), endDate: format(endDate, 'yyyy-MM-dd') }),
    signal,
  });
  if (!response.ok) throw new Error(`Failed to fetch invoices: ${response.status} ${response.statusText}`);
  return response.json();
}

export async function fetchFactuur(id: string, signal?: AbortSignal): Promise<Factuur> {
  const token = await getAccessToken();
  const response = await fetch(`/api/facturen/${encodeURIComponent(id)}`, {
    headers: { Authorization: `Bearer ${token}` },
    signal,
  });
  if (!response.ok) throw new Error(`Failed to fetch invoice: ${response.status} ${response.statusText}`);
  return response.json();
}
